import { withAuth } from '../../Authentication';
import NoDownload from './NoDownload';

export default withAuth(NoDownload);
